import MuiBox, {BoxProps} from '@new-components/atoms/MuiBox';

type PanelProps = {
  activeTab: string | number;
  value: string | number;
  children?: React.ReactNode;
  sx?: BoxProps['sx'];
};
function Panel(props: PanelProps) {
  return (
    <MuiBox
      role='tabpanel'
      hidden={props.activeTab !== props.value}
      id={`simple-tabpanel-${props.value}`}
      aria-labelledby={`simple-tab-${props.value}`}
      sx={props.sx}>
      {props.activeTab === props.value && props.children}
    </MuiBox>
  );
}

export default Panel;
